import React, { useState } from 'react';
import { ShoppingBag, User, Heart, Search, Menu, X, ArrowRight, ChevronRight, Plus, Play, Star, Zap, Shield, Truck } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const Template19 = () => {
    const navigate = useNavigate();
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
    const [hoveredProduct, setHoveredProduct] = useState(null);

    const collections = [
        { name: 'Activewear', tagline: 'Move with Confidence', image: 'https://images.unsplash.com/photo-1518310383802-640c2de311b2?w=800&h=1000&fit=crop', count: '86' },
        { name: 'Athleisure', tagline: 'Gym to Street', image: 'https://images.unsplash.com/photo-1571019614242-c5c5dee9f50b?w=800&h=1000&fit=crop', count: '124' },
        { name: 'Loungewear', tagline: 'Comfort First', image: 'https://images.unsplash.com/photo-1515886657613-9f3515b0c78f?w=800&h=1000&fit=crop', count: '68' },
    ];

    const products = [
        { name: 'High-Waist Leggings', price: 2499, color: 'Black', image: 'https://images.unsplash.com/photo-1518310383802-640c2de311b2?w=500&h=650&fit=crop', hoverImage: 'https://images.unsplash.com/photo-1571019614242-c5c5dee9f50b?w=500&h=650&fit=crop', tag: 'Bestseller', colors: ['#000', '#3B82F6', '#10B981'] },
        { name: 'Sports Bra - Mesh', price: 1899, color: 'Navy', image: 'https://images.unsplash.com/photo-1571019614242-c5c5dee9f50b?w=500&h=650&fit=crop', hoverImage: 'https://images.unsplash.com/photo-1518310383802-640c2de311b2?w=500&h=650&fit=crop', tag: 'New', colors: ['#1E40AF', '#000', '#EC4899'] },
        { name: 'Performance Tank', price: 1599, color: 'White', image: 'https://images.unsplash.com/photo-1515886657613-9f3515b0c78f?w=500&h=650&fit=crop', hoverImage: 'https://images.unsplash.com/photo-1496747611176-843222e1e57c?w=500&h=650&fit=crop', tag: null, colors: ['#FFF', '#000', '#6B7280'] },
        { name: 'Training Shorts', price: 1799, color: 'Grey', image: 'https://images.unsplash.com/photo-1496747611176-843222e1e57c?w=500&h=650&fit=crop', hoverImage: 'https://images.unsplash.com/photo-1515886657613-9f3515b0c78f?w=500&h=650&fit=crop', tag: null, colors: ['#6B7280', '#000', '#10B981'] },
        { name: 'Yoga Pants', price: 2299, color: 'Olive', image: 'https://images.unsplash.com/photo-1583391733956-3750e0ff4e8b?w=500&h=650&fit=crop', hoverImage: 'https://images.unsplash.com/photo-1594938298603-c8148c4dae35?w=500&h=650&fit=crop', tag: 'Limited', colors: ['#4D7C0F', '#000', '#7C3AED'] },
        { name: 'Track Jacket', price: 3499, color: 'Black', image: 'https://images.unsplash.com/photo-1594938298603-c8148c4dae35?w=500&h=650&fit=crop', hoverImage: 'https://images.unsplash.com/photo-1583391733956-3750e0ff4e8b?w=500&h=650&fit=crop', tag: 'New', colors: ['#000', '#DC2626', '#3B82F6'] },
        { name: 'Cropped Hoodie', price: 2799, color: 'Rose', image: 'https://images.unsplash.com/photo-1564257631407-4deb1f99d992?w=500&h=650&fit=crop', hoverImage: 'https://images.unsplash.com/photo-1558171813-4c088753af8f?w=500&h=650&fit=crop', tag: null, colors: ['#FB7185', '#000', '#6B7280'] },
        { name: 'Seamless Set', price: 3999, color: 'Sage', image: 'https://images.unsplash.com/photo-1558171813-4c088753af8f?w=500&h=650&fit=crop', hoverImage: 'https://images.unsplash.com/photo-1564257631407-4deb1f99d992?w=500&h=650&fit=crop', tag: 'Set', colors: ['#84CC16', '#000', '#F97316'] },
    ];

    const features = [
        { icon: Zap, title: 'Quick Dry', desc: '4-way stretch fabric' },
        { icon: Shield, title: 'Squat Proof', desc: 'Full coverage guaranteed' },
        { icon: Truck, title: 'Free Shipping', desc: 'On orders over ₹1,499' },
    ];

    const reviews = [
        { text: 'Best leggings I have ever owned. The fit is perfect and they do not roll down during workouts!', name: 'Priya M.', rating: 5 },
        { text: 'Finally found activewear that is both stylish and functional. The quality is amazing.', name: 'Sneha K.', rating: 5 },
        { text: 'Love the seamless collection. So comfortable for yoga and everyday wear.', name: 'Anita R.', rating: 5 },
    ];

    return (
        <div className="w-full min-h-screen bg-white font-sans">
            {/* Top Bar */}
            <div className="bg-black text-white text-center py-2.5 text-xs tracking-wider font-medium">
                FREE SHIPPING ON ORDERS OVER ₹1,499 | EASY 30-DAY RETURNS
            </div>

            {/* Header */}
            <header className="bg-white sticky top-0 z-50 border-b border-gray-100">
                <div className="max-w-screen-2xl mx-auto">
                    <div className="flex items-center justify-between px-4 lg:px-8 py-4">
                        {/* Mobile Menu */}
                        <button className="lg:hidden" onClick={() => setMobileMenuOpen(!mobileMenuOpen)}>
                            {mobileMenuOpen ? <X className="w-6 h-6 text-black" /> : <Menu className="w-6 h-6 text-black" />}
                        </button>

                        {/* Logo */}
                        <h1 onClick={() => navigate('/template19')} className="text-2xl lg:text-3xl font-black tracking-tight text-black cursor-pointer">
                            ZEST
                        </h1>

                        {/* Desktop Nav */}
                        <nav className="hidden lg:flex items-center gap-8">
                            <button onClick={() => navigate('/template19/shop')} className="text-sm font-semibold text-gray-700 hover:text-black transition-colors">
                                SHOP ALL
                            </button>
                            <button className="text-sm font-semibold text-gray-700 hover:text-black transition-colors">
                                NEW ARRIVALS
                            </button>
                            <button className="text-sm font-semibold text-gray-700 hover:text-black transition-colors">
                                BESTSELLERS
                            </button>
                            <button className="text-sm font-semibold text-gray-700 hover:text-black transition-colors">
                                SALE
                            </button>
                        </nav>

                        {/* Icons */}
                        <div className="flex items-center gap-4">
                            <Search className="w-5 h-5 text-gray-700 cursor-pointer hover:text-black transition-colors" />
                            <User className="w-5 h-5 text-gray-700 cursor-pointer hover:text-black transition-colors hidden sm:block" onClick={() => navigate('/template19/profile')} />
                            <div className="relative cursor-pointer" onClick={() => navigate('/template19/cart')}>
                                <ShoppingBag className="w-5 h-5 text-gray-700 hover:text-black transition-colors" />
                                <span className="absolute -top-1 -right-1 w-4 h-4 bg-black text-white text-[10px] rounded-full flex items-center justify-center font-bold">0</span>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Mobile Menu */}
                {mobileMenuOpen && (
                    <div className="lg:hidden bg-white border-t border-gray-100">
                        <nav className="px-4 py-6 space-y-4">
                            <button onClick={() => { navigate('/template19/shop'); setMobileMenuOpen(false); }} className="block text-lg font-bold text-black">SHOP ALL</button>
                            <button className="block text-lg font-bold text-black">NEW ARRIVALS</button>
                            <button className="block text-lg font-bold text-black">BESTSELLERS</button>
                            <button onClick={() => { navigate('/template19/contact'); setMobileMenuOpen(false); }} className="block text-lg font-bold text-black">CONTACT</button>
                        </nav>
                    </div>
                )}
            </header>

            {/* Hero Section */}
            <section className="relative h-[90vh] bg-black">
                <img
                    src="https://images.unsplash.com/photo-1518310383802-640c2de311b2?w=1920&h=1080&fit=crop"
                    alt="Hero"
                    className="w-full h-full object-cover opacity-80"
                />
                <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/40 to-transparent"></div>

                <div className="absolute inset-0 flex items-center">
                    <div className="max-w-screen-2xl mx-auto px-4 lg:px-8 w-full">
                        <div className="max-w-xl">
                            <p className="text-lime-400 text-sm font-bold tracking-wider mb-4">NEW COLLECTION</p>
                            <h1 className="text-5xl lg:text-7xl font-black text-white mb-6 leading-none">
                                MOVE WITH<br />
                                <span className="text-lime-400">POWER</span>
                            </h1>
                            <p className="text-gray-300 text-lg mb-8 max-w-md">
                                Performance activewear designed for women who push limits. Comfort meets style.
                            </p>
                            <div className="flex flex-wrap gap-4">
                                <button
                                    onClick={() => navigate('/template19/shop')}
                                    className="group px-8 py-4 bg-lime-400 text-black font-bold tracking-wide hover:bg-lime-300 transition-colors inline-flex items-center gap-2"
                                >
                                    SHOP NOW <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
                                </button>
                                <button className="px-8 py-4 border-2 border-white text-white font-bold tracking-wide hover:bg-white hover:text-black transition-colors">
                                    LEARN MORE
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Features Bar */}
            <section className="bg-lime-400 py-4">
                <div className="max-w-screen-2xl mx-auto px-4 lg:px-8">
                    <div className="flex flex-wrap justify-center items-center gap-8 lg:gap-16">
                        {features.map((feature, idx) => (
                            <div key={idx} className="flex items-center gap-3">
                                <feature.icon className="w-5 h-5 text-black" />
                                <div>
                                    <span className="font-bold text-black text-sm">{feature.title}</span>
                                    <span className="text-black/70 text-sm ml-2">{feature.desc}</span>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* Shop by Category */}
            <section className="py-16 lg:py-24">
                <div className="max-w-screen-2xl mx-auto px-4 lg:px-8">
                    <div className="flex items-end justify-between mb-10">
                        <div>
                            <p className="text-lime-500 text-sm font-bold tracking-wider mb-2">CATEGORIES</p>
                            <h2 className="text-3xl lg:text-4xl font-black text-black">Shop by Style</h2>
                        </div>
                        <button className="hidden md:flex items-center gap-2 text-sm font-bold text-gray-700 hover:text-black transition-colors">
                            VIEW ALL <ChevronRight className="w-4 h-4" />
                        </button>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-3 gap-4 lg:gap-6">
                        {collections.map((col, idx) => (
                            <div key={idx} className="group cursor-pointer relative overflow-hidden">
                                <div className="aspect-[4/5] overflow-hidden">
                                    <img
                                        src={col.image}
                                        alt={col.name}
                                        className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                                    />
                                </div>
                                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent"></div>
                                <div className="absolute bottom-0 left-0 right-0 p-6">
                                    <p className="text-lime-400 text-xs font-bold tracking-wider mb-1">{col.tagline.toUpperCase()}</p>
                                    <h3 className="text-2xl font-black text-white mb-2">{col.name}</h3>
                                    <p className="text-white/70 text-sm">{col.count} products</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* Video Section */}
            <section className="relative h-[60vh] bg-black">
                <img
                    src="https://images.unsplash.com/photo-1571019614242-c5c5dee9f50b?w=1600&h=900&fit=crop"
                    alt="Video"
                    className="w-full h-full object-cover opacity-60"
                />
                <div className="absolute inset-0 flex items-center justify-center">
                    <div className="text-center">
                        <button className="w-20 h-20 bg-lime-400 rounded-full flex items-center justify-center mb-6 mx-auto hover:scale-110 transition-transform">
                            <Play className="w-8 h-8 text-black ml-1" />
                        </button>
                        <p className="text-lime-400 text-sm font-bold tracking-wider mb-2">WATCH</p>
                        <h2 className="text-4xl lg:text-5xl font-black text-white">The Movement</h2>
                    </div>
                </div>
            </section>

            {/* Products Grid */}
            <section className="py-16 lg:py-24 bg-gray-50">
                <div className="max-w-screen-2xl mx-auto px-4 lg:px-8">
                    <div className="flex items-end justify-between mb-10">
                        <div>
                            <p className="text-lime-500 text-sm font-bold tracking-wider mb-2">TRENDING NOW</p>
                            <h2 className="text-3xl lg:text-4xl font-black text-black">Bestsellers</h2>
                        </div>
                        <button onClick={() => navigate('/template19/shop')} className="hidden md:flex items-center gap-2 text-sm font-bold text-gray-700 hover:text-black transition-colors">
                            SHOP ALL <ChevronRight className="w-4 h-4" />
                        </button>
                    </div>

                    <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 lg:gap-6">
                        {products.map((product, idx) => (
                            <div
                                key={idx}
                                className="group bg-white"
                                onMouseEnter={() => setHoveredProduct(idx)}
                                onMouseLeave={() => setHoveredProduct(null)}
                            >
                                <div className="relative aspect-[3/4] overflow-hidden">
                                    <img
                                        src={hoveredProduct === idx ? product.hoverImage : product.image}
                                        alt={product.name}
                                        className="w-full h-full object-cover transition-all duration-500"
                                    />
                                    {product.tag && (
                                        <span className="absolute top-3 left-3 bg-black text-white text-[10px] font-bold tracking-wider px-3 py-1.5">{product.tag.toUpperCase()}</span>
                                    )}
                                    <button className="absolute top-3 right-3 w-9 h-9 bg-white rounded-full flex items-center justify-center opacity-0 group-hover:opacity-100 transition-all duration-300 shadow-sm">
                                        <Heart className="w-4 h-4 text-gray-700" />
                                    </button>
                                    <button className="absolute bottom-3 left-3 right-3 py-3 bg-black text-white text-xs font-bold tracking-wider opacity-0 group-hover:opacity-100 translate-y-2 group-hover:translate-y-0 transition-all duration-300 flex items-center justify-center gap-2">
                                        <Plus className="w-4 h-4" /> QUICK ADD
                                    </button>
                                </div>
                                <div className="p-4">
                                    <div className="flex gap-1.5 mb-2">
                                        {product.colors.map((color, i) => (
                                            <span key={i} className="w-3 h-3 rounded-full border border-gray-200" style={{ backgroundColor: color }}></span>
                                        ))}
                                    </div>
                                    <h3 className="text-sm font-bold text-black mb-1">{product.name}</h3>
                                    <p className="text-sm text-gray-700 font-medium">₹{product.price.toLocaleString()}</p>
                                </div>
                            </div>
                        ))}
                    </div>

                    <div className="text-center mt-10 md:hidden">
                        <button onClick={() => navigate('/template19/shop')} className="text-sm font-bold text-black border-b-2 border-black pb-1">
                            VIEW ALL PRODUCTS
                        </button>
                    </div>
                </div>
            </section>

            {/* Reviews */}
            <section className="py-16 lg:py-24">
                <div className="max-w-screen-xl mx-auto px-4 lg:px-8">
                    <div className="text-center mb-12">
                        <p className="text-lime-500 text-sm font-bold tracking-wider mb-2">REVIEWS</p>
                        <h2 className="text-3xl lg:text-4xl font-black text-black">What Our Customers Say</h2>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                        {reviews.map((review, idx) => (
                            <div key={idx} className="bg-gray-50 p-6">
                                <div className="flex gap-1 mb-4">
                                    {[...Array(review.rating)].map((_, i) => (
                                        <Star key={i} className="w-4 h-4 fill-lime-400 text-lime-400" />
                                    ))}
                                </div>
                                <p className="text-gray-700 mb-4 leading-relaxed">"{review.text}"</p>
                                <p className="font-bold text-black">{review.name}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* CTA Banner */}
            <section className="bg-black py-16 lg:py-20">
                <div className="max-w-screen-xl mx-auto px-4 lg:px-8 text-center">
                    <h2 className="text-3xl lg:text-5xl font-black text-white mb-6">
                        JOIN THE <span className="text-lime-400">MOVEMENT</span>
                    </h2>
                    <p className="text-gray-400 mb-8 max-w-lg mx-auto">
                        Subscribe for exclusive drops, workout tips, and 10% off your first order.
                    </p>
                    <div className="flex flex-col sm:flex-row gap-3 max-w-md mx-auto">
                        <input
                            type="email"
                            placeholder="Enter your email"
                            className="flex-1 px-5 py-4 bg-gray-900 border-0 text-white text-sm placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-lime-400"
                        />
                        <button className="px-8 py-4 bg-lime-400 text-black text-sm font-bold tracking-wide hover:bg-lime-300 transition-colors">
                            SUBSCRIBE
                        </button>
                    </div>
                </div>
            </section>

            {/* Footer */}
            <footer className="bg-gray-900 text-white">
                <div className="max-w-screen-2xl mx-auto px-4 lg:px-8 py-12 lg:py-16">
                    <div className="grid grid-cols-1 md:grid-cols-4 gap-8 lg:gap-12">
                        <div>
                            <h3 className="text-2xl font-black mb-4">ZEST</h3>
                            <p className="text-gray-400 text-sm leading-relaxed">
                                Performance activewear for women who move. Designed in India.
                            </p>
                        </div>

                        <div>
                            <h4 className="text-xs font-bold tracking-wider mb-4 text-gray-300">SHOP</h4>
                            <ul className="space-y-2 text-sm">
                                <li><span onClick={() => navigate('/template19/shop')} className="text-gray-400 hover:text-white cursor-pointer transition-colors">All Products</span></li>
                                <li><span className="text-gray-400 hover:text-white cursor-pointer transition-colors">New Arrivals</span></li>
                                <li><span className="text-gray-400 hover:text-white cursor-pointer transition-colors">Bestsellers</span></li>
                                <li><span className="text-gray-400 hover:text-white cursor-pointer transition-colors">Sale</span></li>
                            </ul>
                        </div>

                        <div>
                            <h4 className="text-xs font-bold tracking-wider mb-4 text-gray-300">HELP</h4>
                            <ul className="space-y-2 text-sm">
                                <li><span onClick={() => navigate('/template19/contact')} className="text-gray-400 hover:text-white cursor-pointer transition-colors">Contact</span></li>
                                <li><span onClick={() => navigate('/template19/orders')} className="text-gray-400 hover:text-white cursor-pointer transition-colors">Track Order</span></li>
                                <li><span className="text-gray-400 hover:text-white cursor-pointer transition-colors">Size Guide</span></li>
                                <li><span className="text-gray-400 hover:text-white cursor-pointer transition-colors">Returns</span></li>
                            </ul>
                        </div>

                        <div>
                            <h4 className="text-xs font-bold tracking-wider mb-4 text-gray-300">CONNECT</h4>
                            <ul className="space-y-2 text-sm">
                                <li className="text-gray-400">hello@zest.in</li>
                                <li className="text-gray-400">+91 98765 43210</li>
                                <li className="text-gray-400 pt-2">Mon - Sat: 10am - 7pm</li>
                            </ul>
                        </div>
                    </div>

                    <div className="border-t border-gray-800 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
                        <p className="text-gray-500 text-xs">© 2025 Zest. All rights reserved.</p>
                        <div className="flex gap-6 text-xs text-gray-500">
                            <span className="hover:text-white cursor-pointer transition-colors">Privacy</span>
                            <span className="hover:text-white cursor-pointer transition-colors">Terms</span>
                        </div>
                    </div>
                </div>
            </footer>
        </div>
    );
};

export default Template19;
